module.exports = __webpack_public_path__ + "img/21.eed35333.png";